import { render } from "./Icon.vue?vue&type=template&id=06e82f3b"
import script from "./Icon.js?vue&type=script&lang=js&external"
export * from "./Icon.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../../.yarn/$$virtual/vue-loader-virtual-29d36d6b67/0/cache/vue-loader-npm-17.3.1-d00a988f1a-cfa887f74c.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"web/themes/custom/hetdepot/dev/js/vue/components/Icon/Icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06e82f3b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06e82f3b', __exports__)) {
    api.reload('06e82f3b', __exports__)
  }
  
  module.hot.accept("./Icon.vue?vue&type=template&id=06e82f3b", () => {
    api.rerender('06e82f3b', render)
  })

}


export default __exports__